import script from "./assistant-checks-filters.vue?vue&type=script&setup=true&lang=ts"
export * from "./assistant-checks-filters.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__